// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"b4d45b38","415":"c432fa1f"}[chunkId] + ".chunk.js";
};